import * as React from "react";
import { singleton } from "logic/singleton";
const MessageDetailsContext = React.createContext(void 0);
export default singleton("contexts.enterprise.LogViewMessageDetailsContext", () => MessageDetailsContext);
